
export enum CustomerIdTypeCd {
	CUSTOMER_LOCATION_FUNCTION_ID = 'CustomerLocationFunctionId',
	LEGACY_CIS_CUSTOMER_NUMBER = 'LegacyCisCustomerNumber',
	MAD_CODE = 'MadCode'}
